import type { PendingPipelineUpload } from "@/lib/pipelineTypes";

/**
 * Same-tab handoff of pending multi-file uploads from Home → /pipeline.
 * File blobs cannot survive a refresh; consume once with take().
 */
export type PipelineUploadHandoff = {
  entries: PendingPipelineUpload[];
  providerId?: string | null;
};

let pending: PipelineUploadHandoff | null = null;

export function setPipelineUploadHandoff(handoff: PipelineUploadHandoff): void {
  pending = handoff.entries.length > 0 ? handoff : null;
}

/** Returns and clears any pending handoff. */
export function takePipelineUploadHandoff(): PipelineUploadHandoff | null {
  const next = pending;
  pending = null;
  return next;
}

export function peekPipelineUploadHandoff(): PipelineUploadHandoff | null {
  return pending;
}
